<template>
  <v-layout>
    <v-flex
      xs12
      class="mb-3"
    >
      <div class="sponsor-box">
        <v-layout
          class="align-center justify-center"
          :wrap="$vuetify.breakpoint.mdAndDown"
        >
          <v-flex
            xs12
            lg6
            :shrink="$vuetify.breakpoint.lgAndUp"
            :mr-3="$vuetify.breakpoint.lgAndUp"
          >
            <h3
              class="font-weight-bold text-uppercase black--text sponsor-title mobile text-xs-center text-lg-right"
              :class="{
                desktop: $vuetify.breakpoint.lgAndUp,
                'mb-3': $vuetify.breakpoint.mdAndDown
              }"
            >
              <span v-html="$t('sponsor.bnp')" />
            </h3>
          </v-flex>
          <v-flex
            xs12
            lg6
            :ml-3="$vuetify.breakpoint.lgAndUp"
          >
            <v-img
              :class="{ 'mx-auto': $vuetify.breakpoint.mdAndDown }"
              :src="require('@/assets/images/sponsors/logo_bnp_moja_wiosna_desktop.png')"
              max-width="359px"
              max-height="79px"
              contain
            />
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
    name: 'BNPHomeSponsorBox'
};
</script>

<style lang="scss" scoped>
.sponsor-box {
  padding: 25px 30px 25px;
  border: 2px solid #008352 !important;
  background-color: #ffffff;
  .sponsor-title {
    &.mobile {
      font-size: 13px;
    }
    &.desktop {
      font-size: 1.9rem;
    }
  }
}
</style>
